




















































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { ExpandingListData, ExpandingListItem } from '@/types';
import { Getter } from 'vuex-class';
import AdditionalInfoBlock from '@/components/additional-info-block.vue';
import { alphabeticalSorter } from '@/utils/array';

@Component({
  name: 'expanding-list',
  components: {
    AdditionalInfoBlock,
  },
})
export default class extends Vue {
  private tag = this.$options.name as string;
  private expandedStates: boolean[] = [];

  @Prop({type: Boolean, default: false})
  private expandAll!: boolean;

  @Prop({type: Object, required: true})
  private readonly data!: ExpandingListData;

  @Prop({type: Number, required: true})
  private readonly itemIndex!: number;

  @Getter('dataManagement/themeColor')
  private themeColor!: CSSStyleDeclaration['color'];

  @Getter('dataManagement/cardBgColor')
  private cardBgColor!: CSSStyleDeclaration['color'];

  // created () {
  //   console.log('sortedDataItems', this.sortedDataItems.map(item => item.content));
  // }

  public mounted(): void  {
    this.$el.addEventListener('keydown', (e: Event) => {
      if ((e as KeyboardEvent).key === 'Enter') {
        const indexId = (e.target as HTMLElement)?.attributes.getNamedItem('indexid')?.value;
        if (indexId !== undefined) {
          this.changeExpandedState(+indexId);
        }
      }
    });
  }

  private get sortedDataItems(): ExpandingListItem[] {
    return this.data.items
      .sort((a, b) => {
        /* sort additional_info type to bottom */
        if (a.subtype === 'additional_info') {
          return 0;
        } else {
          return alphabeticalSorter(a.title, b.title);
        }
      });
  }

  private changeExpandedState(index: number): void {
    if (this.expandedStates[index] === true) {
      this.expandedStates[index] = false;
    } else {
      this.expandedStates[index] = true;
    }
    this.expandedStates = [...this.expandedStates];
  }

  private addHoverColor(event: MouseEvent, isHovered: boolean): void {
    const target: HTMLDivElement = event.target as HTMLDivElement;
    if (isHovered && this.themeColor) {
      target.style.backgroundColor = this.themeColor;
      target.style.color = 'white';
    } else {
      target.style.backgroundColor = 'white';
      target.style.color = 'inherit';
    }
  }

  private expandContentItem(event: MouseEvent, index: number): void {
    this.changeExpandedState(index);
  }

  // private isContentItemsSomeFilled(items: ExpandingListItem[]): boolean {
  //   return items.some && items.some((item) => {
  //     return item.content && item.content.some((content) => Boolean(content));
  //   });
  // }
}
